//Get VS Markers
export const GET_VS_MARKERS = 'GET_VS_MARKERS';
